import AboutPage from "../pages/AboutPage";
import RedirectYourBananasPage from "../pages/RedirectYourBananasPage";
import BananaStandPage from "../pages/BananaStandPage";
import FaqPage from "../pages/FaqPage";
import GlossaryPage from "../pages/GlossaryPage";
import LandingPage from "../pages/LandingPage";
import HowItWorksPage from "../pages/HowItWorksPage";
import LoginPage from "../pages/LoginPage";
import ProfilePage from "../pages/ProfilePage";
import SendBananaPage from "../pages/send-banana/SendBananaPage";
import SetUsernamePage from "../pages/SetUsernamePage";
import ViewBananaPage from "../pages/view-banana/ViewBananaPage";
import BananaverseLivePage from "../pages/BananaverseLivePage";
import ManagePaymentsPage from "../pages/manage/ManagePaymentsPage";
import RedirectBananaStandPage from "../pages/RedirectBananaStandPage";
import YourBananasPage from "../pages/YourBananasPage";
import RelayDashboardPage from "../pages/manage/RelayDashboardPage";

interface RouteType {
  path: string;
  component: any;
  protected: boolean;
}

const routes: RouteType[] = [
  {
    path: "",
    component: LandingPage,
    protected: false,
  },
  {
    path: "/how-it-works",
    component: HowItWorksPage,
    protected: false,
  },
  {
    path: "/about",
    component: AboutPage,
    protected: false,
  },
  {
    path: "/faq",
    component: FaqPage,
    protected: false,
  },
  {
    path: "/glossary",
    component: GlossaryPage,
    protected: false,
  },
  {
    path: "/log-in",
    component: LoginPage,
    protected: false,
  },
  {
    path: "/banana-stand",
    component: BananaStandPage,
    protected: false,
  },
  {
    path: "/banana-hammock",
    component: RedirectYourBananasPage,
    protected: true,
  },  
  {
    path: "/your-bananas",
    component: YourBananasPage,
    protected: true,
  },
  {
    path: "/bananaverse-live",
    component: BananaverseLivePage,
    protected: false,
  },
  {
    path: "/view-banana/:publicId",
    component: ViewBananaPage,
    protected: false,
  },
  {
    path: "/view-banana/id/:privateId",
    component: ViewBananaPage,
    protected: false,
  },
  {
    path: "/tuttobanana",
    component: SendBananaPage,
    protected: true,
  },
  {
    path: "/set-username",
    component: SetUsernamePage,
    protected: true,
  },
  {
    path: "/acquire",
    component: RedirectBananaStandPage,
    protected: true,
  },
  {
    path: "/buy",
    component: RedirectBananaStandPage,
    protected: true,
  },
  {
    path: "/profile",
    component: ProfilePage,
    protected: true,
  },
  {
    path: "/payment-settings",
    component: ManagePaymentsPage,
    protected: true,
  },
  {
    path: "/relay-dashboard",
    component: RelayDashboardPage,
    protected: true,
  },
];

export default routes;
